import React from 'react';
import { Outlet } from 'react-router-dom';
import Footer from '../Footer/Footer';
import './PublicLayout.css';

const PublicLayout = () => {
  return (
    <div className="public-layout">
      <main className="public-content">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
};

export default PublicLayout;
